import { autoinject } from "aurelia-framework";
import { FetchClient } from "../common/fetch-client";
import { ApplicationEnum } from "../enums/ApplicationEnum";
import { IPaginationNew } from "../resources-vue/vue-interfaces/i-pagination";
import { ServiceLocation } from "../resources-vue/vue-models/location-service";

@autoinject
export class LocationService {
    private _fetchClient: FetchClient;
    private _baseUrl: string = "/api/v1/patients";

    public constructor(fetchClient: FetchClient) {
        this._fetchClient = fetchClient;
    }

    public async getServiceLocations(patientId: string, requestQuery: IGetServiceLocations) {
        return await this._fetchClient
            .build(`${this._baseUrl}/${patientId}/servicelocations`)
            .useQueryString(requestQuery)
            .fetch<IPaginationNew<IServiceLocationResponse>>();
    }

    public async saveServiceLocations(patientId: string, payload: ServiceLocation) {
        return await this._fetchClient
            .build(`${this._baseUrl}/${patientId}/servicelocations`)
            .useMethod("POST")
            .useBody(payload)
            .fetchNoContent();
    }

    public async deleteServiceLocation(
        payload: IDeleteServiceLocationQuery,
        patientId: string,
        serviceLocationId: string
    ) {
        return await this._fetchClient
            .build(`${this._baseUrl}/${patientId}/servicelocations/${serviceLocationId}`)
            .useMethod("DELETE")
            .useBody(payload)
            .fetchNoContent();
    }

    public async editServiceLocation(payload: ServiceLocation, patientId: string, serviceLocationId: string) {
        return await this._fetchClient
            .build(`${this._baseUrl}/${patientId}/servicelocations/${serviceLocationId}`)
            .useMethod("PUT")
            .useBody(payload)
            .fetch<ISaveServiceLocationResponse>();
    }
}

export interface IGetServiceLocations {
    page?: number;
    pageSize?: number;
    application: ApplicationEnum;
    accountId: string;
}
export interface IServiceLocationResponse {
    Id: string;
    Code: number;
    Start: string;
    StartTime: string;
}

export interface ISaveServiceLocationResponse {
    IsSuccessful: boolean;
    Message: string;
}

// export interface IPostServiceLocationQuery {
//     agencyId: string;
//     application: ApplicationEnum;
//     Code: number;
//     Start: string;
//     StartTime: string;
// }

export interface IDeleteServiceLocationQuery {
    agencyId: string;
    application: ApplicationEnum;
}
